import React, { useState, useCallback } from "react";
import getDateString from "./lib/getDateString";

function DatePicker(props) {
  const { date, onDateChange } = props;
  const currentDate = new Date();
  const maxDateTime = new Date(new Date().setDate(currentDate.getDate() + 60));
  const minDate = getDateString(currentDate);
  const maxDate = getDateString(maxDateTime);

  const handleDateChange = (event) => {
    onDateChange(event.target.value);
  };

  return (
    <input 
      type="date" 
      min={minDate} 
      max={maxDate} 
      onChange={handleDateChange} 
      value={date} 
    />
  );
}


export default DatePicker;